// 环境配置
export default {
    // 线上环境
    prod: {
        // baseUrl: 'http://192.168.12.82:80' //正式环境
        baseUrl: 'https://wechat.lanmaomobile.com' //正式环境
        // baseUrl: 'https://apptest.lanmaomobile.com' //测试环境
        // baseUrl: 'http://a3vjur.natappfree.cc' //测试
        // baseUrl: 'http://172.16.30.204:18080'
    },
    //显示loading框的接口列表
    "SHOW_LOADING_REQUEST_LIST": [
        "/api/gzh/login",       // 开卡登录
        "/api/gzh/simOrServiceIdQuery",     // 号卡查询接口
        "/api/gzh/addOpenCardLocation", //新增开卡记录
        "/api/gzh/uploadCard",  //上传签名
        "/api/gzh/queryOpenCardLocation",   // 查询开卡记录
        "/api/gzh/signatureUpload", //上传合拍接口
        "/api/gzh/getSimpleOrCardNum",  // 获取实名认证验证信息
        "/api/gzh/getUrl",  // 获取实名认证链接
        "/api/gzh/dosubmit",    // 开成卡提交
        "/api/gzh/doCheckIdentityCodeByWorkNo",     // 一证五户校验
        "/api/gzh/checkoffername",      //未激活号码套餐展示
        "/api/gzh/fundPoolRecharge",    //  资金池支付
        "/api/wechat/getPhoneById",     // pc开卡通过订单号查询的手机号
        "/api/gzh/getSeesion",      // 获取token
        "/api/gzh/getBossUrl",      // 获取实名认证地址
        "api/gzh/wxPay",
        "/api/wechat/personTransAcctTForm",// 个人实名补录
        "/api/wechat/newTransAcctTForm",// 实名补录
        "/api/wechat/newGetImgPath",// 实名补录检测结果
    ]
}